import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-gray-300 px-6 sm:px-4 py-12 md:px-20">
      <div className="max-w-7xl mx-auto grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-10">
        {/* Logo & Description */}
        <div className="md:col-span-2 sm:col-span-1">
          <img
            src="/skyglobal-removebg-preview.svg"
            alt="Skyglobal Logo"
            className="h-24 mb-4"
          />
          <p className="text-sm text-gray-400 leading-6 mb-4">
            {t("footer.description")}
          </p>
          <p className="text-sm text-bgYellow italic">
            {t("footer.tagline")}
          </p>
        </div>

        {/* Company Links */}
        <div>
          <h4 className="text-base font-semibold text-white mb-4">
            {t("footer.company")}
          </h4>
          <ul className="space-y-2">
            <li>
              <NavLink to="/about" className="text-sm hover:text-bgYellow transition">
                {t("navbar.about")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/solutions" className="text-sm hover:text-bgYellow transition">
                {t("navbar.solutions")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className="text-sm hover:text-bgYellow transition">
                {t("navbar.contact")}
              </NavLink>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="md:col-span-2 sm:col-span-1">
          <h4 className="text-base font-semibold text-white mb-4">
            PT. SKYGLOBAL TEKNOLOGI INDONESIA
          </h4>
          <ul className="text-sm space-y-3">
            <li className="flex items-center gap-2">
              <MapPin size={16} className="text-bgYellow flex-shrink-0" />
              <span>Jl. Kejaksaan V G.172, Pondok Bambu, Duren Sawit, Jakarta Timur</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={16} className="text-bgYellow flex-shrink-0" />
              <span>+62 811 8128 8777</span>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-bgYellow flex-shrink-0" />
              <span>bisnis@skyglobal.co.id</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-10 border-t border-gray-700 pt-6 text-sm text-center text-gray-500">
        © {new Date().getFullYear()} PT Skyglobal Teknologi Indonesia. {t("footer.rights")}
      </div>
    </footer>
  );
};

export default Footer;
